import React from 'react'
import { Input, Select } from 'components/common'

export default class PostalCode extends React.Component {
	constructor(props) {
		super(props)
		this.state = {
			options: props.model && props.name && props.model[props.name]
				? [{[props.name]: props.model[props.name]}]
				: null
		}
	}

	onChange = (selected) => {
		const { model, onChange } = this.props

		model.postal_description = selected.postal_description
		if (model.hasOwnProperty('district_code')) {
			model.district_code = selected.district_code
		}
		if (model.hasOwnProperty('province_code')) {
			model.province_code = selected.province_code
		}
		if (onChange) {
			onChange(selected)
		}
	}

	render() {
		const { model, name, required, disabled } = this.props
		const { options } = this.state
		const component = model.foreign_contacts == 1
			?	<Input model={model} name={name} required={required} classNameControl='postal_code' readOnly={disabled || null} />
			:	<Select classNameSelect="postal-code" placeholder="(cód.postal)" model={model} name={name} required={required}
					url='/ctts/codes.json'
					options={options}
					optionValue='postal_code'
					optionLabel='postal_code'
					onChange={this.onChange}
					disabled={disabled || null}
				/>

		return (
			<div className='d-flex'>
				{component}
				<Input model={model} name="postal_description" disabled={disabled || null} />
			</div>
		)
	}
}